<template>
  <app-page>
    <template v-if="$route.query.inApp != 3 || $route.query.isShowTitle">
      <app-header slot="header" :title="$route.meta.title"></app-header>
    </template>
    <div class="header">
      <img src="https://res.jaadee.net/active/course/about/banner.jpg">
      <ul class="tabs">
        <li
            class="tab"
            v-for="(value, index) in tabs"
            :class="{ 'is-active': index === tab }"
            :key="index"
            @click="goRoute(index, value.route)"
        >
          {{ value.title }}
        </li>
      </ul>
    </div>
    <div class="content">
<!--      <router-view />-->
      <brief-introduction v-show="tab==0"></brief-introduction>
      <founder-introduction v-show="tab==1"></founder-introduction>
      <corporate-culture v-show="tab==2"></corporate-culture>
      <honour v-show="tab==3"></honour>
      <history v-show="tab==4"></history>
    </div>
  </app-page>
</template>

<script>
import AppPage from "../layouts/Main";
import AppHeader from "../layouts/Header";
import BriefIntroduction from "@/views/about/components/us/BriefIntroduction";
import FounderIntroduction from "@/views/about/components/us/FounderIntroduction";
import CorporateCulture from "@/views/about/components/us/CorporateCulture";
import Honour from "@/views/about/components/us/Honour";
import History from "@/views/about/components/us/History";
export default {
  name: "us",
  components: {
    History,
    Honour,
    FounderIntroduction,
    BriefIntroduction,
    CorporateCulture,
    AppPage,
    AppHeader,
  },
  data() {
    return {
      tabs: [
        {
          title: "公司简介",
          route: "about.us",
          path: "",
        },
        {
          title: "创始人介绍",
          route: "about.founder",
          path: "",
        },
        {
          title: "企业文化",
          route: "about.culture",
          path: "",
        },
        {
          title: "所获荣誉",
          route: "about.honour",
          path: "",
        },
        {
          title: "发展历程",
          route: "about.history",
          path: "",
        },
      ],
      tab: 0,
    };
  },
  computed: {},
  mounted() {
    this.$nextTick(() => {
      if (this.$route.matched.length >= 2) {
        this.tab = this.$route.matched[2].meta.tab;
      }
    });
  },
  methods: {
    goRoute(index, val) {
      this.tab = index;
      // this.$router.push({ name: val });
    },
  },
};
</script>

<style lang="scss" scoped >
.header {
  height: 3.73rem;
  background-size: cover;
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  .tabs {
    background-color: rgba(1, 84, 42, 1);
    display: flex;
    margin-top: -0.50rem;
    width: 100%;
    .tab {
      position: relative;
      display: flex;
      align-items: center;
      flex-grow: 1;
      justify-content: center;
      height: 0.59rem;
      font-size: 0.1733rem;
      color: rgba(255, 255, 255, 0.7);
    }
    .tab.is-active {
      color: rgba(255, 255, 255, 1);
    }
    .tab.is-active::after {
      content: "";
      position: absolute;
      background-color: rgba(255, 255, 255, 0.7);
      width: 44%;
      height: 0.016rem;
      border-radius: 0.1rem;
      bottom: 0.12rem;
      left: 28%;
    }
  }
}
</style>
